export default "__VITE_ASSET__DVDfvi9A__"